<script>
export default {
  name: 'MaterialRoomList',
  model: { prop: 'value', event: 'change' },
  props: {
    items: Array,
    value: Array,
  },
  computed: {
    uniqueValues() {
      return this.value.filter(v => !this.items.includes(v));
    },
    allItems() {
      return [...new Set([...this.items, ...this.value])];
    },
  },
  methods: {
    async add() {
      const newRoom = await this.$prompt('Укажите название помещения');
      if (!newRoom) return;

      this.$emit('change', [...this.value, newRoom]);
    },
    toggle(item) {
      const newValue = this.value.includes(item)
        ? this.value.filter(v => v !== item)
        : [...this.value, item];
      this.$emit('change', newValue);
    },
  },
};
</script>

<template lang="pug">
.material-room-list
  button.item(
    v-for="item in allItems"
    :key="item"
    :class="{ checked: value.includes(item) }"
    @click="toggle(item)"
  ) {{ item }}
    Icon(name="cross" pointer)
  button.item(@click="add")
    Icon(name="plus" pointer colored)
    | Добавить помещение
</template>

<style scoped lang="scss">
.material-room-list {
  display: flex;
  gap: 20px;
  flex-wrap: wrap;

  & :last-child {

    svg {
      display: block;
      color: #33A1FB;
    }
  }
}

.item {
  background: #F5F7F9;
  border-radius: 20px;
  display: flex;
  gap: 15px;
  align-items: center;
  font-size: 14px;
  font-weight: 400;
  line-height: 28px;
  color: #92A0B0;
  padding: 0 22px;
  cursor: pointer;



  svg {
    display: none;
  }

  &.checked {
    background: #33A1FB;
    color: #fff;



    svg {
      display: block;
    }
  }
}
</style>
